/**
 * alpinejs directive to use tailwind breakpoints - responsive tailwind
 */
document.addEventListener('alpine:init', () => {
  Alpine.directive('rtw', (el, {value, modifiers, expression}, {Alpine, evaluateLater, evaluate, effect, cleanup}) => {
    /**
     * get screens from tailwind config
     */
    const screens = {
      'xs': '480px',
      'sm': '640px',
      'md': '768px',
      'lg': '1024px',
      'xl': '1280px',
    };
    const mediaQuery = typeof screens[value] === 'string' ? `(max-width: ${screens[value]})` : null;

    if (!mediaQuery || typeof expression !== 'string') {
      return;
    }

    const mediaQueryListener = window.matchMedia(mediaQuery);
    const matches = mediaQueryListener.matches;
    const handler = () => {
      if(mediaQueryListener.matches) {
        el.classList.add(expression);
      }
      else {
        el.classList.remove(expression);
      }
    }

    handler();
    mediaQueryListener.addEventListener('change', handler);
    cleanup(() => mediaQueryListener.removeEventListener('change', handler));
  })
})
